import { memo, useEffect, useRef } from 'react'
import { getLineData } from './utils'
import { observer } from 'mobx-react-lite'
import { useStore } from '@/store/index'
import BigNumber from 'bignumber.js'

interface BaseAreaChartProps {
  width?: string
  height?: number
  lineConfig?: any
  data: Array<[number, number]>
  baseLine: number
  rate_value?: string
}

const BaseAreaChart: React.FC<BaseAreaChartProps> = ({
  width = '120px',
  height = '32px',
  lineConfig,
  data,
  baseLine,
  rate_value,
  ...rest
}) => {
  const { riseColorValue = 'red' } = useStore().globalStore
  const chartRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const { Area } = require('@antv/g2plot')

    const { data: chartData, xMinDada, yMinDada, yMaxDada } = getLineData(data, baseLine)
    // 判断值是大于0 还是小于0 大于0是涨小于0是跌 然后再根据判断 红涨绿跌还是绿涨红跌
    const color =
      rate_value && BigNumber(rate_value).isGreaterThan(0)
        ? riseColorValue !== 'green'
          ? '#F2495E'
          : '#30BF87'
        : riseColorValue === 'green'
        ? '#F2495E'
        : '#30BF87'

    const config = {
      data: chartData,
      xField: 'x',
      yField: 'y',
      smooth: true,
      xAxis: {
        range: [0, 1],
        min: xMinDada,
        line: false,
        tickLine: false,
        label: false,
        grid: {
          line: false,
        },
      },
      yAxis: {
        min: yMinDada,
        line: false,
        tickLine: false,
        label: false,
        grid: {
          line: false,
        },
      },
      tooltip: false,
      color: 'transparent',
      annotations: [
        {
          type: 'regionFilter',
          start: ['min', 'max'],
          end: ['max', '0'],
          color: riseColorValue === 'green' ? '#30BF87' : '#F2495E',
        },
        {
          type: 'regionFilter',
          start: ['min', '0'],
          end: ['max', 'min'],
          color: riseColorValue !== 'green' ? '#30BF87' : '#F2495E',
        },
      ],
      areaStyle: () => ({
        fill: 'transparent',
        lineWidth: 0,
      }),
      ...lineConfig,
    }

    // 若是数据没有变化，显示一条直线
    if (yMinDada === yMaxDada) {
      config.color = color
      config.line = {
        size: 3,
      }
      delete config.annotations
    }

    const line = new Area(chartRef.current, config)

    line.render()

    return () => {
      line?.destroy()
    }
  }, [baseLine, data, lineConfig, riseColorValue, rate_value])

  return <div ref={chartRef} style={{ width, height }} {...rest} />
}

export default memo(observer(BaseAreaChart), (val, oldval) => {
  return JSON.stringify(val.data) === JSON.stringify(oldval.data) || val.rate_value === oldval.rate_value
})
